module.exports = __webpack_public_path__ + "img/door.7a0e2870.png";